import React, { useState } from "react";
import { FiSend, FiMail, FiMapPin } from "react-icons/fi";
import SEO from "../components/SEO";
import Layout from "../components/Layout";
import site from "../data/site";

const Contact = () => {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({
    name: "", company: "", email: "", phone: "", topic: "General enquiry", message: ""
  });

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    // Client-side only; wire to back-end / mailer when ready.
    setSent(true);
  };

  return (
    <Layout>
      <SEO title="Contact" description={`Get in touch with ${site.brand} — based in ${site.location.city}, ${site.location.country}.`} />

      <section className="service-hero">
        <div className="container">
          <div className="crumbs">
            <a href="/">Home</a><span className="sep">/</span> Contact
          </div>
          <span className="eyebrow eyebrow--light">Get in touch</span>
          <h1>Bring us a problem worth solving.</h1>
          <p className="lead">
            Tell us what you are trying to change. We respond within one business day with a clear next step — even if that step isn't us.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <span className="eyebrow">Direct lines</span>
              <h2 style={{ fontSize: "1.8rem" }}>The fastest paths in.</h2>
              <p style={{ color: "#5b6a7f", marginBottom: "2rem" }}>
                For most enquiries the form on the right is the quickest route. If you prefer, the channels below land directly with the right team.
              </p>

              <div className="info-block">
                <div className="label"><FiMail style={{ marginRight: 6 }} /> E-mail</div>
                <a className="value" href={`mailto:${site.contact.email}`}>{site.contact.email}</a>
              </div>
              <div className="info-block">
                <div className="label"><FiMapPin style={{ marginRight: 6 }} /> Office</div>
                <div className="value" style={{ lineHeight: 1.5 }}>
                  {site.location.address.line1}<br />
                  {site.location.address.line2}<br />
                  {site.location.address.city}, {site.location.address.country}
                </div>
              </div>
            </div>

            <div className="contact-form">
              {sent ? (
                <div style={{ textAlign: "center", padding: "2rem 0" }}>
                  <h3>Thank you.</h3>
                  <p style={{ color: "#5b6a7f" }}>
                    Your message is on its way. A senior team member will reply within one business day.
                  </p>
                </div>
              ) : (
                <form onSubmit={submit}>
                  <h3 style={{ marginBottom: ".25rem" }}>Send us a brief.</h3>
                  <p style={{ color: "#5b6a7f", fontSize: ".95rem", marginBottom: "1.5rem" }}>
                    A few lines is enough — we will ask the right follow-up questions.
                  </p>

                  <div className="field field--row">
                    <div>
                      <label>Full name</label>
                      <input required value={form.name} onChange={update("name")} placeholder="Jane Doe" />
                    </div>
                    <div>
                      <label>Company</label>
                      <input value={form.company} onChange={update("company")} placeholder="Company name" />
                    </div>
                  </div>

                  <div className="field field--row">
                    <div>
                      <label>E-mail</label>
                      <input required type="email" value={form.email} onChange={update("email")} placeholder="you@company.com" />
                    </div>
                    <div>
                      <label>Phone</label>
                      <input value={form.phone} onChange={update("phone")} placeholder="+971 ..." />
                    </div>
                  </div>

                  <div className="field">
                    <label>Topic</label>
                    <select value={form.topic} onChange={update("topic")}>
                      <option>General enquiry</option>
                      <option>New project / RFP</option>
                      <option>Managed services</option>
                      <option>Cyber security incident</option>
                      <option>Partnership</option>
                    </select>
                  </div>

                  <div className="field">
                    <label>Message</label>
                    <textarea
                      required
                      value={form.message}
                      onChange={update("message")}
                      placeholder="Tell us what you are trying to change, and any constraints we should know about."
                    />
                  </div>

                  <div className="submit-row">
                    <button type="submit" className="btn btn--primary">
                      Send brief <FiSend />
                    </button>
                  </div>

                  <p className="form-note">
                    By submitting, you agree that {site.brand} may contact you about your enquiry. We never share or sell submitted information.
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
